<template>
  <div class="selection-page" v-if="users">
    <div class="radio-buttons">
      <input
        type="radio"
        id="users"
        value="Potential Students"
        v-model="selectedOption"
      />
      <label
        for="users"
        :class="{ selected: selectedOption === 'Potential Students' }"
        >Potential Students</label
      >
      <input
        type="radio"
        id="instructors"
        value="Potential Instructors"
        v-model="selectedOption"
      />
      <label
        for="instructors"
        :class="{ selected: selectedOption === 'Potential Instructors' }"
        >Potential Instructors</label
      >
    </div>
    <div class="row button-margins justify-content-between">
      <hilo-button
        label="Add +"
        @click="
          selectedOption === 'Potential Students'
            ? navigateToAddStudent()
            : navigateToAddInstructor()
        "
      />
      <hilo-button
        :label="
          showEmailTemplates ? 'Hide Email Templates' : 'Show Email Templates'
        "
        @click="toggleShowEmailTemplates"
      />
    </div>
    <hilo-table
      v-if="selectedOption === 'Potential Students'"
      :columns="columns"
      :data="users"
    />
    <hilo-table
      v-if="selectedOption === 'Potential Instructors'"
      :columns="instructorCol"
      :data="users"
    />
    <email-templates
      v-if="showEmailTemplates"
      :templates="emailTemplates"
      @save-templates="saveEmailTemplateChanges"
    />

    <hilo-modal
      :isVisible="showApplicationEmailModal"
      title="Confirm Application Email"
      :data="selectedPotentialUser"
      :showCloseButton="false"
      :footerButtons="applicationEmailFooterButtons"
      @close="closeModal('showApplicationEmailModal')"
    >
      <div>
        <div>
          Please confirm that you would like to send the following application
          email.
        </div>
        <br />
        <div>Subject: {{ selectedPotentialUser.subject }}</div>
        <br />
        <div v-html="selectedPotentialUser.body"></div>
      </div>
    </hilo-modal>
    <hilo-modal
      :isVisible="showOrientationEmailModal"
      title="Confirm Orientation Email"
      :data="selectedPotentialUser"
      :showCloseButton="false"
      :footerButtons="orientationEmailFooterButtons"
      @close="closeModal('showOrientationEmailModal')"
    >
      <div>
        <div>
          Please confirm that you would like to send the following orientation
          email.
        </div>
        <br /><br />
        <div>Subject: {{ selectedPotentialUser.subject }}</div>
        <br />
        <div v-html="selectedPotentialUser.body"></div>
      </div>
    </hilo-modal>
    <hilo-modal
      :isVisible="showStudentOnboardingModal"
      title="Finalize Onboarding"
      :data="selectedPotentialUser"
      :showCloseButton="false"
      :footerButtons="studentOnboardingFooterButtons"
      @close="closeModal('showStudentOnboardingModal')"
    >
      <div style="max-height: 70vh; overflow-y: auto; padding-right: 10px">
        <h4>
          Tuition Amount:
          {{ selectedPotentialUser.studentFinancing?.tuitionAmount }}
        </h4>
        <h4>
          Financing Method:
          {{
            selectedPotentialUser.studentFinancing?.financingMethodId === 1
              ? "Cash"
              : "Financing"
          }}
        </h4>
        <h4
          v-if="selectedPotentialUser.studentFinancing?.financingMethodId === 4"
        >
          Credit Score:
          {{
            selectedPotentialUser.studentFinancing
              ?.creditCheckIntelligenceName || "Unknown"
          }}
        </h4>
        <h4
          v-if="selectedPotentialUser.studentFinancing?.financingMethodId === 4"
        >
          Full Credit Check Info:
          <span v-html="formattedCreditCheckDataHtml"></span>
        </h4>
      </div>
    </hilo-modal>
    <hilo-modal
      :isVisible="showInstructorOnboardingModal"
      title="Finalize Onboarding"
      :data="selectedPotentialUser"
      :showCloseButton="false"
      :footerButtons="instructorOnboardingFooterButtons"
      @close="closeModal('showInstructorOnboardingModal')"
    >
      <div style="max-height: 70vh; overflow-y: auto; padding-right: 10px">
        <h4>
          Please confirm {{ selectedPotentialUser.firstName }}
          {{ selectedPotentialUser.lastName }} has uploaded the required
          documents and is ready to be onboarded.
        </h4>
        <h4>
          Once the onboarding is finalized, this student will no longer be
          visible on this page and will be moved to the Students page.
        </h4>
        <br />
        <div style="text-align: center">
          <h4>Profile Photo</h4>
          <img
            :src="selectedPotentialUser.image"
            alt="Profile"
            style="
              width: 400px;
              height: 400px;
              object-fit: cover;
              margin-bottom: 20px;
            "
          />
          <h4>Photo Id</h4>
          <img
            :src="selectedPotentialUser.photoId"
            alt="Photo Id"
            style="
              width: 400px;
              height: 400px;
              object-fit: cover;
              margin-bottom: 20px;
            "
          />
          <h4 v-if="selectedPotentialUser.commercialCert">
            Commercial Certificate
          </h4>
          <img
            v-if="selectedPotentialUser.commercialCert"
            :src="selectedPotentialUser.commercialCert"
            alt="Commercial Cert"
            style="
              width: 400px;
              height: 400px;
              object-fit: cover;
              margin-bottom: 20px;
            "
          />
          <h4>Medical Certificate</h4>
          <img
            :src="selectedPotentialUser.medicalCert"
            alt="Medical Certificate"
            style="
              width: 400px;
              height: 400px;
              object-fit: cover;
              margin-bottom: 20px;
            "
          />
          <h4>Birth Certificate</h4>
          <img
            :src="selectedPotentialUser.birthCert"
            alt="Birth Certificate"
            style="
              width: 400px;
              height: 400px;
              object-fit: cover;
              margin-bottom: 20px;
            "
          />
          <h4 v-if="selectedPotentialUser.quoteImage">Quote</h4>
          <object
            v-if="selectedPotentialUser.quoteImage"
            :data="selectedPotentialUser.quoteImage"
            type="application/pdf"
            width="400px"
            height="600px"
            style="margin-bottom: 20px"
          >
            Your browser does not support viewing PDFs. Please download the PDF
            to view it:
            <a :href="selectedPotentialUser.quoteImage" download
              >Download Quote</a
            >
          </object>
        </div>
      </div>
    </hilo-modal>
  </div>
</template>

<script>
import HiloButton from "src/components/HiloComponents/HiloButton.vue";
import HiloModal from "src/components/HiloComponents/HiloModal.vue";
import HiloTable from "src/components/HiloComponents/HiloTable.vue";
import EmailTemplates from "src/components/HiloComponents/EmailTemplates.vue";
import PotentialStudentsAPIService from "src/servicehandlers/PotentialStudentsAPIService.js";
import PotentialInstructorsAPIService from "src/servicehandlers/PotentialInstructorsAPIService";
import EmailAPIService from "src/servicehandlers/EmailAPIService";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import emailUtils from "@/util/emails";

const emailAPIService = new EmailAPIService();

dayjs.extend(utc);

export default {
  components: {
    HiloButton,
    HiloModal,
    HiloTable,
    EmailTemplates,
  },
  data() {
    return {
      selectedOption: "Potential Students",
      users: [],
      studentEmailTemplateNames: [
        {
          name: "Student Application",
          title: "Application Email Template",
          variables: this.getApplicationEmailVariables(),
        },
        {
          name: "Student Orientation",
          title: "Orientation Email Template",
          variables: this.getOrientationEmailVariables("Potential Students"),
        },
      ],
      instructorEmailTemplateNames: [
        {
          name: "Instructor Application",
          title: "Application Email Template",
          variables: this.getInstructorApplicationEmailVariables(),
        },
        {
          name: "Instructor Orientation",
          title: "Orientation Email Template",
          variables: this.getOrientationEmailVariables("Potential Instructors"),
        },
      ],
      showStudentOnboardingModal: false,
      showInstructorOnboardingModal: false,
      showApplicationEmailModal: false,
      showOrientationEmailModal: false,
      selectedPotentialUser: {},
      showEmailTemplates: false,
      emailTemplates: [],
      columns: [
        {
          key: "id",
          component: "HiloButton",
          componentProps: (row) => ({
            styleType: "editIcon",
            onClick: () =>
              this.selectedOption === "Potential Students"
                ? this.navigateToEditStudent(row.id)
                : this.navigateToEditInstructor(row.id),
          }),
        },
        { key: "lastName", label: "Last" },
        { key: "firstName", label: "First" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        {
          key: "quoteId",
          label: "Quote",
          component: "HiloButton",
          componentProps: (row) => ({
            styleType: row.quoteId ? "white" : "default",
            label: row.quoteId ? "View" : "Create",
            onClick: () =>
              row.quoteId
                ? this.navigateToEditQuote(row)
                : this.navigateToAddQuote(row),
          }),
        },
        { key: "fundingId", label: "Funding" },
        { key: "initialSitDown", label: "Initial Sit-Down" },
        { key: "followUp", label: "Follow Up" },
        {
          key: "applicationEmailSent",
          label: "Application Email",
          component: "HiloButton",
          componentProps: (row) => ({
            styleType: row.applicationEmailSent
              ? "greenCheckButton"
              : "default",
            label: row.applicationEmailSent ? "Sent" : "Send",
            onClick: () => this.handleApplicationEmailClick(row),
          }),
        },
        {
          key: "orientationEmailSent",
          label: "Orientation Email",
          component: "HiloButton",
          componentProps: (row) => ({
            styleType: row.orientationEmailSent
              ? "greenCheckButton"
              : "default",
            label: this.getOrientationEmailLabel(row),
            onClick: () => this.handleOrientationEmailClick(row),
            disabled:
              !row.quoteId && this.selectedOption === "Potential Students",
          }),
        },
        { key: "contractValue", label: "Contract Value" },
        {
          key: "onboarded",
          label: "Onboarding",
          component: "HiloButton",
          componentProps: (row) => ({
            label: this.getOnboardingLabel(row),
            onClick: () => this.handleOnboardingClick(row),
            disabled: this.shouldDisableOnboarding(row),
          }),
        },
      ],
      instructorCol: [],
      APIService: null,
    };
  },
  async mounted() {
    await this.setAPIService();
    await this.getPotentialUsers();
    await this.setEmailTemplate();
    this.filterPotentialInstructors(this.columns);
  },
  watch: {
    selectedOption: {
      immediate: true,
      handler(newVal) {
        this.setAPIService();
        this.setEmailTemplate();
        this.users = [];
        this.getPotentialUsers();
        this.showEmailTemplates = false;

        if (newVal === "Potential Students") {
          this.studentEmailTemplateNames = [
            {
              name: "Student Application",
              title: "Application Email Template",
              variables: this.getApplicationEmailVariables(),
            },
            {
              name: "Student Orientation",
              title: "Orientation Email Template",
              variables:
                this.getOrientationEmailVariables("Potential Students"),
            },
          ];
        } else if (newVal === "Potential Instructors") {
          this.instructorEmailTemplateNames = [
            {
              name: "Instructor Application",
              title: "Application Email Template",
              variables: this.getInstructorApplicationEmailVariables(),
            },
            {
              name: "Instructor Orientation",
              title: "Orientation Email Template",
              variables: this.getOrientationEmailVariables(
                "Potential Instructors",
              ),
            },
          ];
        }
      },
    },
  },
  computed: {
    applicationEmailFooterButtons() {
      return emailUtils.generateFooterButtons(
        () => this.closeModal("showApplicationEmailModal"),
        this.sendApplicationEmail,
      );
    },
    orientationEmailFooterButtons() {
      return emailUtils.generateFooterButtons(
        () => this.closeModal("showOrientationEmailModal"),
        this.sendOrientationEmail,
      );
    },
    studentOnboardingFooterButtons() {
      return emailUtils.generateFooterButtons(
        () => this.closeModal("showStudentOnboardingModal"),
        this.confirmConvertToActiveUser,
        "Finalize Onboarding",
      );
    },
    instructorOnboardingFooterButtons() {
      return emailUtils.generateFooterButtons(
        () => this.closeModal("showInstructorOnboardingModal"),
        this.confirmConvertToActiveUser,
        "Finalize Onboarding",
      );
    },
    formattedCreditCheckDataHtml() {
      const data = this.selectedPotentialUser.studentFinancing?.creditCheckData;
      if (!data) return "No Data Available";

      let parsedData;
      try {
        parsedData = typeof data === "string" ? JSON.parse(data) : data;
      } catch (error) {
        return "Invalid JSON data";
      }

      return JSON.stringify(parsedData, null, 2)
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\n/g, "<br>")
        .replace(/\s/g, "&nbsp;");
    },
  },
  beforeRouteEnter(to, from, next) {
    if (/^\/hilo\/crm\/addEditInstructor(\/\d+)?$/.test(from.fullPath)) {
      next((vm) => {
        vm.selectedOption = "Potential Instructors";
      });
    } else {
      next();
    }
  },
  methods: {
    setAPIService() {
      if (this.selectedOption === "Potential Students") {
        this.APIService = new PotentialStudentsAPIService();
      } else {
        this.APIService = new PotentialInstructorsAPIService();
      }
    },
    async setEmailTemplate() {
      if (this.selectedOption === "Potential Students") {
        this.emailTemplates = await emailUtils.getEmailTemplates(
          this.studentEmailTemplateNames,
        );
      } else {
        this.emailTemplates = await emailUtils.getEmailTemplates(
          this.instructorEmailTemplateNames,
        );
      }
    },
    async getPotentialUsers() {
      return this.APIService.get(this.$router)
        .then((response) => {
          this.users = response.map((potentialUser) => {
            potentialUser.lastName = potentialUser.user.lastName;
            potentialUser.firstName = potentialUser.user.firstName;
            potentialUser.phone = potentialUser.user.phone || "-";
            potentialUser.email = potentialUser.user.email;
            potentialUser.fundingId = potentialUser.funding
              ? potentialUser.funding.name
              : "-";
            potentialUser.followUp = potentialUser.followUp
              ? dayjs(potentialUser.followUp).utc().format("MM/DD/YY")
              : "-";
            potentialUser.initialSitDown = potentialUser.initialSitDown
              ? dayjs(potentialUser.initialSitDown).utc().format("MM/DD/YY")
              : "-";
            potentialUser.contractValue = this.getContractValue(
              potentialUser.quote,
            );
            potentialUser.onboarding = potentialUser.user.onboarding;
            potentialUser.studentFinancing =
              potentialUser.user.studentFinancing;
            potentialUser.onboardingKey = potentialUser.user.onboardingKey;
            if (
              potentialUser.user.image &&
              typeof potentialUser.user.image === "string"
            ) {
              potentialUser.image = `${process.env.VUE_APP_API_URL}/file_uploads/${potentialUser.user.image.split("/").pop()}`;
            }
            if (
              potentialUser.user.onboarding?.photoId &&
              typeof potentialUser.user.onboarding?.photoId === "string"
            ) {
              potentialUser.photoId = `${process.env.VUE_APP_API_URL}/file_uploads/${potentialUser.user.onboarding.photoId.split("/").pop()}`;
            }
            if (
              potentialUser.user.onboarding?.commercialCert &&
              typeof potentialUser.user.onboarding?.commercialCert === "string"
            ) {
              potentialUser.commercialCert = `${process.env.VUE_APP_API_URL}/file_uploads/${potentialUser.user.onboarding.commercialCert.split("/").pop()}`;
            }
            if (
              potentialUser.user.onboarding?.medicalCert &&
              typeof potentialUser.user.onboarding?.medicalCert === "string"
            ) {
              potentialUser.medicalCert = `${process.env.VUE_APP_API_URL}/file_uploads/${potentialUser.user.onboarding.medicalCert.split("/").pop()}`;
            }
            if (
              potentialUser.user.onboarding?.birthCert &&
              typeof potentialUser.user.onboarding?.birthCert === "string"
            ) {
              potentialUser.birthCert = `${process.env.VUE_APP_API_URL}/file_uploads/${potentialUser.user.onboarding.birthCert.split("/").pop()}`;
            }
            if (
              potentialUser.quote?.image &&
              typeof potentialUser.quote?.image === "string"
            ) {
              potentialUser.quoteImage = `${process.env.VUE_APP_API_URL}/file_uploads/${potentialUser.quote.image.split("/").pop()}`;
            }

            return potentialUser;
          });
        })
        .catch((error) => {
          this.error_txt = "Failed to get users: " + error;
        });
    },
    getContractValue(quote) {
      if (quote) {
        return (
          parseFloat(quote.privatePrice) +
          parseFloat(quote.instrumentPrice) +
          parseFloat(quote.commercialPrice) +
          parseFloat(quote.cfiPrice) +
          parseFloat(quote.cfiiPrice) +
          parseFloat(quote.commMultiPrice) +
          parseFloat(quote.meiPrice) +
          parseFloat(quote.crewPrice) +
          parseFloat(quote.simPrice) +
          parseFloat(quote.checkridePricePerTest) *
            parseFloat(quote.checkrideTests) +
          parseFloat(quote.knowledgePricePerTest) *
            parseFloat(quote.knowledgeTests) +
          parseFloat(quote.reserveAmount) +
          parseFloat(quote.stipendPayment1) +
          parseFloat(quote.stipendPayment2) +
          parseFloat(quote.stipendPayment3) +
          parseFloat(quote.monthlyHousing) +
          parseFloat(quote.seatCharge)
        ).toLocaleString("en-US", { style: "currency", currency: "USD" });
      } else return "-";
    },
    getOnboardingLabel(row) {
      if (this.selectedOption === "Potential Students") {
        return row.studentFinancing === null
          ? "Awaiting Financials"
          : "Finalize Student";
      } else {
        return row.onboarding === null
          ? "Awaiting Uploads"
          : "Finalize Instructor";
      }
    },
    handleOnboardingClick(row) {
      if (this.selectedOption === "Potential Students") {
        this.handleStudentOnboardingClick(row);
      } else {
        this.handleInstructorOnboardingClick(row);
      }
    },
    shouldDisableOnboarding(row) {
      if (this.selectedOption === "Potential Students") {
        return row.studentFinancing === null;
      } else {
        return row.onboarding === null;
      }
    },
    navigateToAddStudent() {
      this.$router.push({ name: "Sign Up" });
    },
    navigateToEditStudent(id) {
      this.$router.push({ name: "Add Edit Potential Student", params: { id } });
    },
    navigateToAddInstructor() {
      this.$router.push({ name: "Add Edit Potential Instructor" });
    },
    navigateToEditInstructor(id) {
      this.$router.push({
        name: "Add Edit Potential Instructor",
        params: { id },
      });
    },
    navigateToAddQuote(row) {
      this.$router.push({
        name: "Add Edit Quote",
        params: {
          name: `${row.firstName} ${row.lastName}`,
          potentialStudentId: row.id,
          previousHours: row.previousHours || 0,
        },
      });
    },
    navigateToEditQuote(row) {
      this.$router.push({
        name: "Add Edit Quote",
        params: {
          id: row.quoteId,
          name: `${row.firstName} ${row.lastName}`,
          previousHours: row.previousHours || 0,
        },
      });
    },
    getOrientationEmailLabel(row) {
      if (!row.quoteId && this.selectedOption === "Potential Students") {
        return "Awaiting Quote";
      }
      return row.orientationEmailSent ? "Sent" : "Send";
    },
    handleApplicationEmailClick(row) {
      this.showApplicationEmailModal = true;
      const applicationTemplate = this.emailTemplates.find(
        (template) => template.title === "Application Email Template",
      );
      this.selectedPotentialUser = {
        ...row,
        subject: applicationTemplate.subject,
        body: this.replacePlaceholders(applicationTemplate.body, row).replace(
          /\n/g,
          "<br>",
        ),
      };
    },
    async sendApplicationEmail() {
      await this.APIService.sendApplicationEmail(
        this.selectedPotentialUser.id,
        { ...this.selectedPotentialUser },
      );
      this.closeModal("showApplicationEmailModal");
      await this.getPotentialUsers();
    },
    handleOrientationEmailClick(row) {
      this.showOrientationEmailModal = true;
      const orientationTemplate = this.emailTemplates.find(
        (template) => template.title === "Orientation Email Template",
      );
      this.selectedPotentialUser = {
        ...row,
        subject: orientationTemplate.subject,
        body: this.replacePlaceholders(orientationTemplate.body, row).replace(
          /\n/g,
          "<br>",
        ),
      };
    },
    async sendOrientationEmail() {
      await this.APIService.sendOrientationEmail(
        this.selectedPotentialUser.id,
        { ...this.selectedPotentialUser },
      );
      this.closeModal("showOrientationEmailModal");
      await this.getPotentialUsers();
    },
    handleStudentOnboardingClick(row) {
      this.showStudentOnboardingModal = true;
      this.selectedPotentialUser = row;
    },
    handleInstructorOnboardingClick(row) {
      this.showInstructorOnboardingModal = true;
      this.selectedPotentialUser = row;
    },
    async confirmConvertToActiveUser() {
      await this.APIService.convertToActive(this.selectedPotentialUser.id);
      this.closeModal("showStudentOnboardingModal");
      this.closeModal("showInstructorOnboardingModal");
      await this.getPotentialUsers();
    },
    closeModal(modalName) {
      this[modalName] = false;
      this.selectedPotentialUser = {};
    },
    toggleShowEmailTemplates() {
      this.showEmailTemplates = !this.showEmailTemplates;
    },
    async saveEmailTemplateChanges(updatedTemplates) {
      await emailUtils.saveEmailTemplates(updatedTemplates);
      this.emailTemplates = updatedTemplates;
    },
    getApplicationEmailVariables() {
      return [
        "{{firstName}}",
        "{{lastName}}",
        "{{email}}",
        "{{phone}}",
        "{{funding}}",
        "{{followUp}}",
        "{{initialSitDown}}",
        "{{contractValue}}",
      ];
    },
    getInstructorApplicationEmailVariables() {
      return [
        "{{firstName}}",
        "{{lastName}}",
        "{{email}}",
        "{{phone}}",
        "{{initialSitDown}}",
      ];
    },
    getOrientationEmailVariables(userType) {
      if (userType === "Potential Students") {
        return this.getApplicationEmailVariables();
      } else {
        const variables = this.getInstructorApplicationEmailVariables();
        variables.push("{{onboardingPageLink}}");
        return variables;
      }
    },
    getOnboardingPageLink(potentialUser) {
      const baseUrl = window.location.origin;
      return `${baseUrl}/onboarding/${potentialUser.userId}/${potentialUser.onboardingKey}`;
    },
    replacePlaceholders(template, potentialUser) {
      return template
        .replace(/{{firstName}}/g, potentialUser.firstName)
        .replace(/{{lastName}}/g, potentialUser.lastName)
        .replace(/{{email}}/g, potentialUser.email)
        .replace(/{{phone}}/g, potentialUser.phone)
        .replace(/{{funding}}/g, potentialUser.fundingId)
        .replace(/{{followUp}}/g, potentialUser.followUp)
        .replace(/{{initialSitDown}}/g, potentialUser.initialSitDown)
        .replace(
          /{{contractValue}}/g,
          this.getContractValue(potentialUser.quote),
        )
        .replace(
          /{{onboardingPageLink}}/g,
          this.getOnboardingPageLink(potentialUser),
        );
    },
    filterPotentialInstructors(col) {
      this.instructorCol = col.map((item) => ({ ...item }));
      this.instructorCol.splice(5, 3);
      this.instructorCol.splice(8, 1);
    },
  },
};
</script>

<style scoped>
.selection-page {
  padding: 0;
}

.radio-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  gap: 10px;
}

input[type="radio"] {
  display: none;
}

label {
  cursor: pointer;
  padding: 10px 20px;
  border: 1px solid black;
  border-radius: 20px;
  background-color: white;
  color: black;
  font-size: 18px;
  margin-bottom: 0;
}

input[type="radio"]:checked + label {
  background-color: black;
  color: white;
}

.selected {
  background-color: black;
  color: white;
}

.button-margins {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -10px 0 10px;
}

.button-margins div {
  display: flex;
  gap: 10px;
}
</style>
